import { useAppSelector } from 'app/hooks';
import { selectChat, updateReplyToMessage } from 'features/auth/chatSlice';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { selectAuth } from 'features/auth/authSlice';

const divStyles = {
  position: 'absolute',
  top: '-60px',
  padding: '5px 20px',
  backgroundColor: 'rgba(0,0,0, 0.4)',
  borderRadius: '10px',
  width: '80%',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  borderLeft: '10px solid #ddb930',
  color: 'white',
  fontWeight: 800,
  justifyContent: 'space-between',
} as React.CSSProperties;

const imgStyles = {
  height: '40px',
  width: '40px',
} as React.CSSProperties;

const ReplyToMessage = () => {
  const chatState = useAppSelector(selectChat);
  const authState = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  const message = chatState.replyToMessage;
  const CardImg = require('assets/AuctionBg.png');
  const handleClick = () =>
    chatState.replyToMessage && dispatch(updateReplyToMessage({}));
  if (chatState.replyToMessage) {
    return (
      <div style={divStyles}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span>
          Replying :&nbsp;
            {chatState.replyToMessage.uid === authState.id
              ? authState.username
              : chatState.replyToMessage.username}
          </span>
          <span>
            {message ? (
              message.type === 'image' || message.type === 'nft' ? (
                <img
                  style={imgStyles}
                  src={message.text || CardImg}
                  alt="reply-media"
                />
              ) : (
                <>
                "{message.text}"
                </>
              )
            ) : (
              <></>
            )}
          </span>
        </div>
        <IconButton onClick={handleClick} color="inherit">
          <ClearIcon />
        </IconButton>
      </div>
    );
  } else {
    return <></>;
  }
};

export default ReplyToMessage;
